export default {
  docs(state) {
    return state.docs;
  },
  totalDocs(state) {
    return state.totalDocs;
  },
  loading(state) {
    return state.loading;
  },
  filter(state) {
    return state.filter;
  },
  page(state) {
    return state.page;
  },
  totalPages(state) {
    return state.totalPages;
  },
};
